module.exports = __webpack_public_path__ + "static/media/4ODA4.f73d61c8.jpg";